import { useTranslation } from 'react-i18next'

import { Modal } from '@hivewatch/dark'
import type { ColorScheme } from '@hivewatch/dark'

import { CaseQuery } from '@/graphql/generated/operations'

import { UpdateCaseForm } from './UpdateCaseForm'

interface UpdateCaseModalIProps {
  colorScheme?: ColorScheme
  isOpen: boolean
  onClose: () => void
  caseData: CaseQuery
}

export const UpdateCaseModal = ({
  colorScheme = 'light',
  isOpen,
  onClose,
  caseData,
}: UpdateCaseModalIProps) => {
  const { t } = useTranslation()

  return (
    <Modal
      bodyStyleOverrides={{ pb: '24px' }}
      colorScheme={colorScheme}
      isOpen={isOpen}
      isSaveHidden
      onClose={onClose}
      size='medium'
      title={t('cases:crud_update_case_modal_title')}
    >
      <UpdateCaseForm
        caseData={caseData}
        colorScheme={colorScheme}
        onClose={onClose}
      />
    </Modal>
  )
}
